import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { loginToMyBiz } from 'apis/commonApis';
import { MYBIZ_DEFAULT_LOGOS, MYBIZ_LOGO_IMAGES, PATHS } from 'AppConstants';
import { GenericDiv, LinearLoader } from 'commonStyles';
import { FlexDiv } from 'commonStyles';
import ApiError from 'common/ApiError/ApiError';

import { getEncodedQueryParams, getValidRedirectUrl } from 'UtilityComponents/Util';

const IntermediatePage = () => {
	const { search } = useLocation() || {};

	const [error, setError] = useState(false);
	useEffect(() => {
		const params = getEncodedQueryParams(search);
		const authToken = params.token || params.data;
		const partnerCode = params['partner-code'];
		const redirectUrl = getValidRedirectUrl(params.redirectUrl);
		if (authToken && partnerCode) {
			loginToMyBiz({ authToken, partnerCode }).then((res) => {
				if (res.error) {
					setError(res.message);
					return;
				}
				const finalRedirectUrl = res.redirectUrl || redirectUrl || PATHS.MMT_MYBIZ;
				// priority given to the redirectUrl from the backend then the redirectUrl from the url params then the default redirect url
				window.location.href = finalRedirectUrl;
			});
		}
	}, []);

	return (
		<FlexDiv $direction='column' align='center' height='100vh'>
			{error ? <ApiError
				$bg='transparent'
				textSize='14'
				imgMargin='45px'
				headSize='20px'
				bottom_P='63'
				top_P='18'
				imgWidth='200px'
				imgHeight='200px'
				$direction='column'
				justify='center'
				align='center'
				ctatext='Go back'
				heading='Login Failed!'
				text4=''
				text1={error}
				clickAction={() => history.back()}
				txtAlign='center'
			/> : (
				<>
					<GenericDiv as='img' bottom_M='20' {...(MYBIZ_LOGO_IMAGES.BY_MMT || MYBIZ_DEFAULT_LOGOS.BY_MMT)} alt='logo' />
					<LinearLoader />
				</>
			)}
		</FlexDiv>
	);
};

export default IntermediatePage;
